import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ClientPortalPage = lazy(() => import('../pages/client-portal/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogPostPage = lazy(() => import('../pages/blog-post/page'));
const TestimonialsPage = lazy(() => import('../pages/testimonials/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin/dashboard/page'));
const TaxCalculatorPage = lazy(() => import('../pages/tax-calculator/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/client-portal',
    element: <ClientPortalPage />,
  },
  {
    path: '/tax-calculator',
    element: <TaxCalculatorPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogPostPage />,
  },
  {
    path: '/testimonials',
    element: <TestimonialsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboardPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
